import { type CSSProperties } from "react";

export const text: CSSProperties = {
  paddingTop: '0.5rem',
  display: 'flex',
  color: 'var(--color-warning-650)',
  flexDirection: 'row',
  alignItems: 'center',
}